import { isApiError } from './error';

const normalizeErrorToken = (value?: string) =>
  value
    ?.trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_');

export const isQuotaExceededError = (error: unknown) => {
  if (!isApiError(error) || error.statusCode !== 403) {
    return false;
  }

  const normalizedErrorCode = normalizeErrorToken(error.errorCode);
  return normalizedErrorCode === 'QUOTA_EXCEEDED';
};
